// extracted by mini-css-extract-plugin
export default {"eachSlideEffect":"merchant-banner_eachSlideEffect__dE02k","sliderLandingPage":"merchant-banner_sliderLandingPage__Lm07X","coverImage":"merchant-banner_coverImage__yY6KD"};